// Added by Sejune Oh on 2020-02-25
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import React, { useEffect, useState } from 'react'
import { createStyles, makeStyles } from '@material-ui/core'

// Interface
import { LCSStatisticStyleTypes } from '@/components/worklist/WebComponents/LCSStatisticWrapper'
export interface HistogramBarChartProps {
  /** 기준이 되는 총 합계 */
  total: number
  /** 히스토그램을 구성하는 부분 데이터 */
  data: HistogramBarPartProps[]
  /** 히스토그램의 높이 */
  barHeight?: number
  /** 히스토그램의 방향 */
  direction?: 'ltr' | 'rtl'
  /** MouseHover시 보여줄 Title 값 */
  tooltipText?: string
  /** WC용 Styles  */
  classes?: LCSStatisticStyleTypes
}

export interface HistogramBarPartProps {
  label: string
  count: number
  color: string
}

// 렌더링 되는 각 파트별 정보
interface PartProps {
  width: string
  left?: string
  right?: string
  backgroundColor: string
}

/**
 * 총 합계 대비 데이터가 차지하는 영역 별 비율로 히스토그램을 보여주는 UI입니다.
 */
const HistogramBarChart = ({
  total,
  data,
  barHeight = 10,
  direction = 'ltr',
  tooltipText: tooltipTextArg,
  classes: webComponentClassses,
  ...rest
}: HistogramBarChartProps) => {
  const classes = webComponentClassses
    ? webComponentClassses['histogrambarchart']
    : makeStyles(() => createStyles({ ...customStyles }))()

  // State
  const [tooltipMessage, setTooltipMessage] = useState('')
  const [parts, setParts] = useState<PartProps[]>([])

  // ! Effect -> For rendering histogram.
  // eslint-disable-next-line
  useEffect(() => setBarParts(), [])
  // eslint-disable-next-line
  useEffect(() => setBarParts(), [data, total, direction])

  // Get Rate
  const getRate = (curCount: number, totalCount: number) => ((curCount / totalCount) * 100).toFixed(0)

  // Set data for render
  const setBarParts = () => {
    const calculatedParts: any[] = []
    const directionPath = direction === 'ltr' ? 'left' : 'right'
    let tooltipText = ''
    let accRate = 0

    // Loop을 돌면서 제공된 값 별로 차지하는 퍼센트와 좌표를 계산하도록 함.
    data.map(({ label, count, color }) => {
      const rate = parseInt(getRate(count, total))
      tooltipText += `${label} : ${count}\n`
      calculatedParts.push({
        [directionPath]: accRate + '%',
        width: rate + '%',
        backgroundColor: color,
      })
      accRate += rate
      return color
    })

    setParts(calculatedParts as PartProps[])
    setTooltipMessage(tooltipTextArg || tooltipText)
  }

  return (
    <div className={classes.wrapper} style={{ height: barHeight + 'px' }} title={tooltipMessage}>
      {parts.map(({ left, right, width, backgroundColor }, index) => (
        <span key={`bar-${width}-${index}`} style={{ left, right, width, backgroundColor }}></span>
      ))}
    </div>
  )
}

export const customStyles: Record<string, any> = {
  wrapper: {
    position: 'relative',
    width: '100%',
    padding: '1px',
    overflow: 'hidden',
    height: 'min-content',
    backgroundColor: '#aeaeae',
    boxSizing: 'content-box',
    border: '1px solid #000',
    color: '#fff',
    '& > span': {
      position: 'absolute',
      width: 0,
      top: 0,
      bottom: 0,
    },
  },
}

export default HistogramBarChart
